import Vue from 'vue';
import { Validator } from 'vee-validate';
import i18n from '@/i18n';
import * as types from './types';

const mutations = {
  [types.RESET_STATE](state) {
    state.authUser = {
      is_employee: false,
      loggedIn: false,
      complete: true,
    };
    state.language = 'de';
    state.predefinedSeason = 'winter';
    state.favorites = [];
    state.notifications = [];
  },
  [types.SET_AUTH_USER](state, userObj) {
    state.authUser = userObj;
  },
  [types.UPDATE_USER_TOKEN](state, token) {
    state.authUser.token = token;
  },
  [types.SET_IN_REGISTRATION_PROCESS](state, inRegistrationProcess) {
    state.inRegistrationProcess = inRegistrationProcess;
  },
  [types.SET_LANGUAGE](state, language) {
    Vue.set(i18n, 'locale', language);
    Vue.set(state, 'language', language);
    Validator.localize(language);
  },
  [types.SET_PROFILE_IMAGE](state, args) {
    Vue.set(state.authUser, 'image', args);
  },
  [types.SET_PREDEFINED_SEASON](state, args) {
    Vue.set(state, 'predefinedSeason', args);
  },
  [types.SHOW_NAVIGATION_DRAWER](state) {
    state.showNavigationDrawer = true;
  },
  [types.HIDE_NAVIGATION_DRAWER](state) {
    state.showNavigationDrawer = false;
  },
  [types.TOGGLE_NAVIGATION_DRAWER](state) {
    state.showNavigationDrawer = !state.showNavigationDrawer;
  },
  // Favorites
  [types.FETCH_FAVORITES_PENDING](state) {
    state.fetchFavoritesPending = true;
  },
  [types.FETCH_FAVORITES_FULFILLED](state, data) {
    state.favorites = data;
    state.fetchFavoritesPending = false;
  },
  [types.FETCH_FAVORITES_ERROR](state) {
    state.fetchFavoritesPending = false;
  },
  [types.ADD_FAVORITE_PENDING](state) {
    state.updateFavoritePending = true;
  },
  [types.ADD_FAVORITE_FULFILLED](state, data) {
    state.favorites.push(data);
    state.updateFavoritePending = false;
  },
  [types.ADD_FAVORITE_ERROR](state) {
    state.updateFavoritePending = false;
  },
  [types.REMOVE_FAVORITE_PENDING](state) {
    state.updateFavoritePending = true;
  },
  [types.REMOVE_FAVORITE_FULFILLED](state, data) {
    const index = state.favorites.findIndex((item) => item.id === data.id);
    state.favorites.splice(index, 1);
    state.updateFavoritePending = false;
  },
  [types.REMOVE_FAVORITE_ERROR](state) {
    state.updateFavoritePending = false;
  },
  // Notifications
  [types.FETCH_NOTIFICATIONS_PENDING](state) {
    state.fetchNotificationsPending = true;
  },
  [types.FETCH_NOTIFICATIONS_FULFILLED](state, notifications) {
    Vue.set(state, 'notifications', notifications.data.data);
    state.fetchNotificationsPending = false;
  },
  [types.FETCH_NOTIFICATIONS_ERROR](state) {
    state.fetchNotificationsPending = false;
  },
  [types.UPDATE_NOTIFICATION_PENDING](state) {
    state.updateNotificationPending = true;
  },
  [types.UPDATE_NOTIFICATION_SUCCESFUL](state) {
    state.updateNotificationPending = false;
  },
  [types.UPDATE_NOTIFICATION_ERROR](state) {
    state.updateNotificationPending = false;
  },
  [types.UPDATE_ALL_NOTIFICATIONS_READ_PENDING](state) {
    state.updateNotificationsPending = true;
    Vue.set(state, 'notifications', []);
  },
  [types.UPDATE_ALL_NOTIFICATIONS_READ_FULFILLED](state) {
    state.updateNotificationsPending = false;
  },
  [types.UPDATE_ALL_NOTIFICATIONS_READ_ERROR](state) {
    state.updateNotificationsPending = false;
  },
  // Send Contact Form
  [types.SEND_CONTACT_FORM_PENDING](state) {
    state.sendContactFormPending = true;
  },
  [types.SEND_CONTACT_FORM_FULFILLED](state) {
    state.sendContactFormPending = false;
  },
  [types.SEND_CONTACT_FORM_ERROR](state) {
    state.sendContactFormPending = false;
  },
  // Register Newsletter Form
  [types.REGISTER_NEWSLETTER_PENDING](state) {
    state.registerNewsletterPending = true;
  },
  [types.REGISTER_NEWSLETTER_FULFILLED](state) {
    state.registerNewsletterPending = false;
  },
  [types.REGISTER_NEWSLETTER_ERROR](state) {
    state.registerNewsletterPending = false;
  },
  // SEND_PASSWORD_RESET_MAIL
  [types.SEND_PASSWORD_RESET_MAIL_PENDING](state) {
    state.sendPasswordResetMailPending = true;
  },
  [types.SEND_PASSWORD_RESET_MAIL_FULFILLED](state) {
    state.sendPasswordResetMailPending = false;
  },
  [types.SEND_PASSWORD_RESET_MAIL_ERROR](state) {
    state.sendPasswordResetMailPending = false;
  },
  // Register Newsletter Form
  [types.SEND_PASSWORD_RESET_PENDING](state) {
    state.sendPasswordResetPending = true;
  },
  [types.SEND_PASSWORD_RESET_FULFILLED](state) {
    state.sendPasswordResetPending = false;
  },
  [types.SEND_PASSWORD_RESET_ERROR](state) {
    state.sendPasswordResetPending = false;
  },
  // FETCH_USER_PROFILE
  [types.FETCH_USER_PROFILE_PENDING](state) {
    state.fetchUserProfilePending = true;
  },
  [types.FETCH_USER_PROFILE_FULFILLED](state, data) {
    state.authUser = data;
    state.fetchUserProfilePending = false;
  },
  [types.FETCH_USER_PROFILE_ERROR](state) {
    state.fetchUserProfilePending = false;
  },
  // UPDATE_USER_PROFILE
  [types.UPDATE_USER_PROFILE_PENDING](state) {
    state.updateUserProfilePending = true;
  },
  [types.UPDATE_USER_PROFILE_FULFILLED](state, { data }) {
    state.updateUserProfilePending = false;
  },
  [types.UPDATE_USER_PROFILE_ERROR](state) {
    state.updateUserProfilePending = false;
  },
};

export default mutations;
